import { useState, useEffect } from "react";
import dayjs from "dayjs";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
  InputLabel,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Grid,
} from "@mui/material";

const emptyTaskData = {
  task_name: "",
  start_date: "",
  end_date: "",
  budget: 0,
  task_type: "FIXED",
  task_description: "",
  status: "WIP",
  parent_task_id: null,
  task_code: "",
};
export default function AddTaskDialog({
  open,
  setOpen,
  onAdd,
  allTasks,
  projectData,
}) {
  const [data, setData] = useState(emptyTaskData);
  const [dateBoundry, setDateBoundry] = useState({
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    setData(emptyTaskData);
  }, [open]);

  const handleDataChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onTaskIdChange = (e) => {
    const { name, value } = e.target;
    let chosenParentTask = allTasks.find((t) => t.id === value);
    setDateBoundry({
      start_date: chosenParentTask.start_date,
      end_date: chosenParentTask.end_date,
    });
    setData((prev) => ({
      ...prev,
      task_code: chosenParentTask.task_code + ".",
      start_date: chosenParentTask.start_date,
      end_date: chosenParentTask.end_date,
      [name]: value || "",
    }));
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        //   setOpen("ADD_TASK");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // const errors = validate(data);
          // if (Object.keys(errors).length === 0) {
          onAdd(data);

          // }
        }}
      >
        <DialogTitle id="alert-dialog-title">Add Task to Project</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ pt: 2 }}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                fullWidth
                label="Name"
                className="name-textfeild"
                name="task_name"
                value={data.task_name}
                onChange={handleDataChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Parent Task
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={data.parent_task_id}
                  label="Parent Task Code"
                  name="parent_task_id"
                  onChange={onTaskIdChange}
                >
                  <MenuItem value="">Choose</MenuItem>
                  {allTasks.map((t, i) => (
                    <MenuItem key={i} value={t.id}>
                      {t.task_code} - {t.task_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                label="Task Code"
                fullWidth
                name="task_code"
                value={data.task_code}
                onChange={handleDataChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label-ts">Status</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label-ts"
                  id="demo-simple-select-ts"
                  value={data.status}
                  label="Status"
                  name="status"
                  onChange={handleDataChange}
                >
                  <MenuItem value="COMPLETED">Completed</MenuItem>
                  <MenuItem value="WIP">In Progress</MenuItem>
                  <MenuItem value="PENDING">Pending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  required
                  inputFormat="MM/dd/yyyy"
                  label="Start Date"
                  value={new Date(data.start_date)}
                  minDate={getMinPossibleTaskStartDate(
                    dateBoundry.start_date,
                    projectData.start_date
                  )}
                  maxDate={
                    new Date(
                      dateBoundry.end_date || new Date(projectData.end_date)
                    )
                  }
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "start_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  required
                  inputFormat="MM/dd/yyyy"
                  label="End Date"
                  value={new Date(data.end_date)}
                  minDate={new Date(data.start_date)}
                  maxDate={getMaxPossibleTaskEndDate(
                    dateBoundry.end_date,
                    projectData.end_date
                  )}
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "end_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6}>
                          <TextField label="Budget" fullWidth name='budget' type="number" value={data.budget} onChange={handleDataChange} />
                      </Grid> */}

            <Grid item xs={12} md={12}>
              <TextField
                label="Description"
                fullWidth
                name="task_description"
                value={data.task_description}
                onChange={handleDataChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen("ADD_TASK");
              setDateBoundry({
                start_date: "",
                end_date: "",
              });
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            // onClick={() => {
            //   onAdd(data);
            // }}
            className="blue-button"
          >
            Add
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

function getMinPossibleTaskStartDate(d1, d2) {
  return dayjs(d1).isAfter(dayjs(d2)) ? new Date(d1) : new Date(d2);
}

function getMaxPossibleTaskEndDate(d1, d2) {
  return dayjs(d1).isBefore(dayjs(d2)) ? new Date(d1) : new Date(d2);
}
